'use strict';

var createPayload = require('./create-payload.js');

module.exports = estimateGas;

/*

This is a work around for https://github.com/ethereum/go-ethereum/issues/2577

*/

function estimateGas(provider, txParams, cb) {
  provider.sendAsync(createPayload({
    method: 'eth_estimateGas',
    params: [txParams]
  }), function (err, res) {
    if (err) {
      // handle simple value transfer case
      if (err.message === 'no contract code at given address') {
        return cb(null, '0xcf08');
      } else {
        return cb(err);
      }
    }
    cb(null, res.result);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ledgerhq/web3-subprovider/node_modules/web3-provider-engine/dist/es5/util/estimate-gas.js
// module id = 1205
// module chunks = 0